import {NotificationService} from '../services';
import {AutoCapturaService} from '../services';
import {EnvService} from '../services';

/**
 * Action Types
 */
export const GET_PARAMETRO_SISTEMA =
  'auto-captura/SystemParameter/GET_PARAMETRO_SISTEMA';
export const GET_PARAMETRO_SISTEMA_SUCCESS =
  'auto-captura/SystemParameter/GET_PARAMETRO_SISTEMA_SUCCESS';
export const GET_PARAMETRO_SISTEMA_FAIL =
  'auto-captura/SystemParameter/GET_PARAMETRO_SISTEMA_FAIL';

/**
 * Reducer
 */
const initialState = {
  valor: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARAMETRO_SISTEMA_SUCCESS:
      return {
        ...state,
        valor: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;

/**
 * Action Creators
 */
const showErrors = (e, service) => {
  if (EnvService.get('ENV') === 'dev') {
    NotificationService.showValidationSingleError(e.problem);
    console.log(`Requisição ${service} com erro :`, e);
  } else
    NotificationService.showValidationSingleError(
      `Não foi possível ${service}. Por favor, tente novamente mais tarde.`,
    );
};

export const parametroSistemaBuscar = (chave) => async (dispatch) => {
  try {
    console.log('Iniciar parametroSistemaBuscar');
    dispatch({type: GET_PARAMETRO_SISTEMA});

    const dadosRequest = {
      chave: chave,
    };

    const response = await AutoCapturaService.getParametroSistema(dadosRequest);

    dispatch({type: GET_PARAMETRO_SISTEMA_SUCCESS, payload: response.valor});
  } catch (e) {
    dispatch({type: GET_PARAMETRO_SISTEMA_FAIL});

    if (e.status === 400)
      NotificationService.showValidationSingleError(
        'Não foi possível buscar o parâmetro de sistema.',
      );
    else showErrors(e, ' buscar o parâmetro de sistema');
  }
};
